import ArticleLayout from '@/pages/article/components/ArticleLayout';

const ARTICLE_SCHEMA = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: 'OOPBUY Anfänger Tipps 2026 – So startest du sicher und stressfrei',
  description: 'Schritt-für-Schritt Anleitung für absolute Neulinge: Vom ersten OOPBUY Spreadsheet bis zur erfolgreichen ersten Bestellung aus China.',
  datePublished: '2026-07-15',
  dateModified: '2026-07-15',
  author: { '@type': 'Organization', name: 'OOPBUY Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'OOPBUY Spreadsheet', url: 'https://oopbuyspread.top' },
  mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://oopbuyspread.top/artikel/oopbuy-anfaenger-tipps' },
});

export default function AnfaengerPage() {
  return (
    <ArticleLayout
      title="OOPBUY Anfänger Tipps 2026 – So startest du sicher und stressfrei"
      description="Schritt-für-Schritt Anleitung für absolute Neulinge: Vom ersten OOPBUY Spreadsheet bis zur erfolgreichen ersten Bestellung aus China."
      heroImage="https://readdy.ai/api/search-image?query=Warm%20inviting%20photograph%20of%20a%20beginners%20desk%20setup%20with%20a%20notebook%20open%20to%20handwritten%20notes%20next%20to%20a%20laptop%20showing%20a%20shopping%20interface%2C%20ceramic%20coffee%20cup%2C%20reading%20glasses%20on%20warm%20oak%20desk%20surface%2C%20gentle%20morning%20sunlight%2C%20cozy%20learning%20atmosphere%2C%20soft%20cream%20and%20warm%20brown%20tones&width=1200&height=500&seq=article-anfaenger-hero&orientation=landscape"
      heroAlt="OOPBUY Anfänger Tipps"
      breadcrumbLabel="Anfänger Tipps"
      schemaMarkup={ARTICLE_SCHEMA}
    >
      <section className="mb-12">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
          Dein Einstieg in die Welt des OOPBUY Spreadsheets
        </h2>
        <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
          <p>
            Der Einstieg in die Welt der chinesischen Shopping-Agenten kann überwältigend wirken. Aber keine Sorge – mit dem <strong>OOPBUY Spreadsheet</strong> und dieser einfachen Anleitung wirst du in kürzester Zeit zum Profi. Dieser Guide richtet sich an absolute Anfänger und führt dich Schritt für Schritt durch den gesamten Prozess.
          </p>
          <p>
            Das Wichtigste zuerst: Das OOPBUY Spreadsheet ist <strong>kostenlos</strong> und wurde genau für Leute wie dich entwickelt – Menschen, die günstige Produkte aus China kaufen möchten, ohne sich durch unzählige chinesische Webseiten kämpfen zu müssen.
          </p>
        </div>
      </section>

      <section className="mb-12">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
          Deine ersten 5 Schritte
        </h2>
        <div className="space-y-4">
          {[
            { step: '1', title: 'Spreadsheet öffnen und Kategorie wählen', desc: 'Starte auf der OOPBUY Spreadsheet Seite und wähle eine Kategorie, die dich interessiert – z.B. Schuhe oder Hoodies.' },
            { step: '2', title: 'Produkt aussuchen', desc: 'Scrolle durch die Liste und suche dir ein Produkt aus. Jeder Eintrag zeigt Preis, Verkäufer und QC-Referenzen.' },
            { step: '3', title: 'Link kopieren', desc: 'Kopiere den Produktlink aus dem Spreadsheet. Diesen fügst du später bei OOPBUY in die Suchleiste ein.' },
            { step: '4', title: 'Bei OOPBUY einfügen und bestellen', desc: 'Erstelle einen OOPBUY Account, füge den Link ein und gib deine Bestellung auf. Bezahle sicher per PayPal.' },
            { step: '5', title: 'QC-Bilder prüfen und freigeben', desc: 'Nach 2-5 Tagen bekommst du QC-Bilder. Prüfe sie und gib den Versand nach Deutschland frei.' },
          ].map((item) => (
            <div key={item.step} className="flex gap-4 bg-background-100 rounded-xl p-5">
              <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
                <span className="text-white text-sm font-bold">{item.step}</span>
              </div>
              <div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-12">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
          Häufige Anfängerfehler vermeiden
        </h2>
        <ul className="space-y-3 text-sm text-foreground-700">
          <li className="flex items-start gap-2">
            <i className="ri-error-warning-line text-amber-500 flex-shrink-0 mt-0.5" />
            <span><strong>Größe falsch gewählt:</strong> Immer die cm-Angaben nutzen, nicht die Buchstaben-Größen (S, M, L).</span>
          </li>
          <li className="flex items-start gap-2">
            <i className="ri-error-warning-line text-amber-500 flex-shrink-0 mt-0.5" />
            <span><strong>Versandkosten unterschätzt:</strong> Versand von 1kg kostet 15-35 €. Mehrere Artikel bündeln spart Geld.</span>
          </li>
          <li className="flex items-start gap-2">
            <i className="ri-error-warning-line text-amber-500 flex-shrink-0 mt-0.5" />
            <span><strong>Zoll ignoriert:</strong> Ab 150 € fallen Zollgebühren an. Bestellungen darunter halten vermeidet Überraschungen.</span>
          </li>
        </ul>
      </section>
    </ArticleLayout>
  );
}